import * as React from "react";
import { Megaphone, Settings2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { cn } from "@/lib/utils";
import { useStore } from "@/context/StoreContext";
import { useAdmin } from "@/context/AdminContext";
import { Button } from "@/components/ui/button";
import { Marquee } from "@/components/ui/marquee";

export const AnnouncementBar = ({ onOpenAdmin }) => {
  const { announcement } = useStore();
  const { isAdmin } = useAdmin();
  const navigate = useNavigate();

  return (
    <div
      className={cn(
        "rounded-2xl border border-white/10",
        "bg-white/5 backdrop-blur-md",
        "px-3 py-2 sm:px-4",
        "shadow-[0_4px_30px_rgba(0,0,0,0.1)]"
      )}
    >
      <div className="flex items-center gap-3">
        <div className="grid size-9 place-items-center rounded-xl bg-accent/70 text-accent-foreground">
          <Megaphone className="size-4" />
        </div>

        <Marquee
          text={announcement}
          className="min-w-0 flex-1 text-sm text-muted-foreground"
          speed={20}
        />

        {isAdmin ? (
          <Button
            variant="glass"
            size="sm"
            className="hidden gap-2 sm:inline-flex"
            onClick={() => navigate("/admin")}
          >
            <Settings2 className="size-4" />
            Admin
          </Button>
        ) : null}
      </div>
    </div>
  );
};
